"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownButton = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_dom_1 = __importDefault(require("react-dom"));
var dom_helpers_1 = require("../util/dom-helpers");
var classnames_1 = require("../util/classnames");
var _1 = require("../util/_");
var popup_1 = require("../popup");
var custom_prop_types_1 = __importDefault(require("../util/custom-prop-types"));
var list_1 = require("../list");
var interaction_1 = require("../util/interaction");
var widget_helpers_1 = require("../util/widget-helpers");
var timeout_manager_1 = require("../util/timeout-manager");
var vdl_prefix_1 = require("../util/vdl-prefix");
var button_1 = require("../button");
var angle_down_1 = __importDefault(require("adp-react-icons/lib/fa/angle-down"));
var focus_mixin_1 = require("../mixins/focus-mixin");
var popup_scroll_manager_1 = require("../util/popup-scroll-manager");
var localizers_1 = require("../util/localizers");
function localizedMessage(messageKey, locale) {
  return localizers_1.message.formatMessage('adp-react-components/list/' + messageKey, undefined, locale);
}
function msgs(msgs, locale) {
  return Object.assign({
    emptyList: localizedMessage('EMPTY_LIST', locale)
  }, msgs);
}
var DropdownButton = /** @class */function (_super) {
  __extends(DropdownButton, _super);
  function DropdownButton() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      focusedItem: _this.props.data ? _this.props.data[0] : undefined,
      open: _this.props.open !== undefined ? _this.props.open : _this.props.defaultOpen || false
    };
    _this._isMounted = false;
    _this._timeoutManager = new timeout_manager_1.TimeoutManager();
    _this._popupScrollManager = new popup_scroll_manager_1.PopupScrollManager();
    _this.setTimeout = function (key, callback, duration) {
      if (_this._isMounted) {
        return _this._timeoutManager.setTimeout(key, callback, duration);
      }
    };
    _this.handleBlur = function (event) {
      focus_mixin_1.handleBlur(_this, event, function (focused) {
        if (!focused) {
          _this.close();
        }
      });
    };
    _this.handleFocus = function (event) {
      focus_mixin_1.handleFocus(_this, event);
    };
    _this.handleAriaActiveDescendant = function (id) {
      if (id === _this.state.ariaActiveDescendant) {
        return;
      }
      _this.setState({
        ariaActiveDescendant: id
      });
    };
    _this._scrollTo = function (selected, list, focused) {
      return _this._popupScrollManager.scrollTo(selected, list, focused, _this.props.onMove);
    };
    //FIXME @widgetEditable
    _this._onSelect = function (data) {
      _this.close();
      widget_helpers_1.notify(_this.props.onSelect, data);
      _this.focus(_this);
    };
    //FIXME @widgetEditable
    _this._click = function (e) {
      if (!_this.state.open) {
        _this.toggle();
      } else {
        _this.close();
      }
      if (!_this.state.open || !dom_helpers_1.contains(react_dom_1.default.findDOMNode(_this._popup), e.target)) {
        widget_helpers_1.notify(_this.props.onClick, e);
      }
    };
    //FIXME @widgetEditable
    _this._keyDown = function (e) {
      var key = e.key;
      var alt = e.altKey;
      var list = _this._list;
      var focusedItem = _this.state.focusedItem;
      var isOpen = _this.state.open;
      var closeWithFocus = function closeWithFocus() {
        _this.close();
        react_dom_1.default.findDOMNode(_this).focus();
      };
      var change = function change(item, fromList) {
        if (!item) {
          return;
        }
        if (fromList) {
          _this._onSelect(item);
        }
      };
      widget_helpers_1.notify(_this.props.onKeyDown, [e]);
      if (e.defaultPrevented) {
        return;
      }
      if (key === 'End') {
        if (isOpen) {
          _this.setState({
            focusedItem: list.last()
          });
        } else {
          change(list.last());
        }
        e.preventDefault();
      } else if (key === 'Home') {
        if (isOpen) {
          _this.setState({
            focusedItem: list.first()
          });
        } else {
          change(list.first());
        }
        e.preventDefault();
      } else if (key === 'Escape' && isOpen) {
        e.preventDefault();
        closeWithFocus();
      } else if ((key === 'Enter' || key === ' ') && isOpen) {
        e.preventDefault();
        change(_this.state.focusedItem, true);
      } else if (key === ' ' && !isOpen) {
        e.preventDefault();
        _this.open();
      } else if (key === 'ArrowDown') {
        if (alt) {
          _this.open();
        } else if (isOpen) {
          _this.setState({
            focusedItem: list.next(focusedItem)
          });
        }
        e.preventDefault();
      } else if (key === 'ArrowUp') {
        if (alt) {
          closeWithFocus();
        } else if (isOpen) {
          _this.setState({
            focusedItem: list.prev(focusedItem)
          });
        }
        e.preventDefault();
      }
    };
    //FIXME @widgetEditable
    _this._keyPress = function (e) {
      widget_helpers_1.notify(_this.props.onKeyPress, [e]);
    };
    _this.focus = function (target) {
      var inst = target || _this._button;
      if (dom_helpers_1.activeElement() !== react_dom_1.default.findDOMNode(inst)) {
        react_dom_1.default.findDOMNode(inst).focus();
      }
    };
    _this._data = function () {
      return _this.props.data ? _this.props.data.concat() : undefined;
    };
    _this.open = function () {
      if (!_this.state.open) {
        _this.setState({
          open: true
        }, function () {
          widget_helpers_1.notify(_this.props.onToggle, true);
        });
      }
    };
    _this.close = function () {
      if (_this.state.open) {
        _this.setState({
          open: false
        }, function () {
          widget_helpers_1.notify(_this.props.onToggle, false);
        });
      }
    };
    _this.toggle = function () {
      if (_this.state.open) {
        _this.close();
      } else {
        _this.open();
      }
    };
    return _this;
  }
  DropdownButton.prototype.componentWillReceiveProps = function (nextProps) {
    var data = this.props.data;
    var open = nextProps.open !== undefined ? nextProps.open : this.state.open;
    var newState = {
      focusedItem: data ? data[0] : undefined
    };
    if (open !== this.state.open) {
      newState.open = open;
    }
    this.setState(newState);
  };
  DropdownButton.prototype.componentDidMount = function () {
    this._isMounted = true;
  };
  DropdownButton.prototype.componentDidUpdate = function () {
    if (this._list) {
      widget_helpers_1.validateList(this._list);
    }
  };
  DropdownButton.prototype.componentWillUnmount = function () {
    this._isMounted = false;
    this._timeoutManager.clearAllTimeouts();
  };
  DropdownButton.prototype.render = function () {
    var _a;
    var _this = this;
    var _b = this.props,
      className = _b.className,
      tabIndex = _b.tabIndex,
      groupBy = _b.groupBy,
      disabledItems = _b.disabledItems,
      data = _b.data,
      busy = _b.busy,
      dropUp = _b.dropUp;
    var List = this.props.listComponent;
    var messages = msgs(this.props.messages);
    var _c = this.state,
      open = _c.open,
      focusedItem = _c.focusedItem,
      focused = _c.focused,
      ariaActiveDescendant = _c.ariaActiveDescendant;
    List = List || groupBy && list_1.ListGroupable || list_1.List;
    var buttonProps = _1.pick(this.props, Object.keys(button_1.Button.propTypes));
    var listProps = _1.pick(this.props, Object.keys(list_1.List.propTypes));
    var popupProps = _1.pick(this.props, Object.keys(popup_1.Popup.propTypes));
    var customProps = _1.omit(this.props, Object.keys(button_1.Button.propTypes).concat(Object.keys(List.propTypes)).concat(Object.keys(popup_1.Popup.propTypes)).concat(Object.keys(DropdownButton.propTypes)));
    var disabled = interaction_1.isDisabled(this.props);
    var readOnly = interaction_1.isReadOnly(this.props);
    var listID = widget_helpers_1.instanceId(this, '__listbox');
    var shouldRenderList = widget_helpers_1.isFirstFocusedRender(this) || open;
    var dropdownButtonClassNames = (_a = {}, _a[vdl_prefix_1.vdlPrefix('dropdown-button')] = true, _a[vdl_prefix_1.vdlPrefix('dropdown-button--disabled')] = disabled, _a[vdl_prefix_1.vdlPrefix('dropdown-button--readonly')] = readOnly, _a[vdl_prefix_1.vdlPrefix('dropdown-button--focus')] = focused, _a[vdl_prefix_1.vdlPrefix('dropdown-button--open')] = open, _a[vdl_prefix_1.vdlPrefix('dropdown-button--dropup')] = dropUp, _a);
    return react_1.default.createElement("div", __assign({}, customProps, {
      className: classnames_1.classNames(className, dropdownButtonClassNames),
      ref: function ref(c) {
        _this._button = c;
      },
      tabIndex: tabIndex || 0,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onKeyDown: this._keyDown,
      onKeyPress: this._keyPress,
      role: "combobox",
      "aria-expanded": open,
      "aria-haspopup": true,
      "aria-owns": listID,
      "aria-busy": !!busy,
      "aria-live": !open && 'polite'
    }), react_1.default.createElement(button_1.Button, __assign({}, buttonProps, {
      onClick: this._click,
      "aria-activedescendant": ariaActiveDescendant
    }), this.props.children, react_1.default.createElement("span", {
      className: vdl_prefix_1.vdlPrefix('dropdown-button__icon')
    }, react_1.default.createElement(angle_down_1.default, null))), react_1.default.createElement(popup_1.Popup, __assign({
      ref: function ref(c) {
        _this._popup = c;
      }
    }, popupProps, {
      open: open,
      className: vdl_prefix_1.vdlPrefix('dropdown-button__popup'),
      style: {},
      onOpen: function onOpen() {
        return _this.focus();
      },
      onOpening: function onOpening() {
        return _this._list.forceUpdate();
      },
      arrow: true
    }), react_1.default.createElement("div", null, shouldRenderList && react_1.default.createElement(List, __assign({
      ref: function ref(c) {
        _this._list = c;
      }
    }, listProps, {
      data: data,
      id: listID,
      "aria-live": open && 'polite',
      "aria-labelledby": widget_helpers_1.instanceId(this),
      "aria-hidden": !open,
      disabled: disabledItems !== undefined ? disabledItems : disabled,
      focused: open ? focusedItem : null,
      onSelect: this._onSelect,
      onMove: this._scrollTo,
      messages: messages,
      onAriaActiveDescendant: this.handleAriaActiveDescendant
    })))));
  };
  DropdownButton.propTypes = Object.assign({}, button_1.Button.propTypes, list_1.ListGroupable.propTypes, {
    //-- controlled props -----------
    open: prop_types_1.default.bool,
    onToggle: prop_types_1.default.func,
    //------------------------------------
    defaultOpen: prop_types_1.default.bool,
    data: prop_types_1.default.array,
    itemComponent: custom_prop_types_1.default.elementType,
    listComponent: custom_prop_types_1.default.elementType,
    groupComponent: custom_prop_types_1.default.elementType,
    groupBy: custom_prop_types_1.default.accessor,
    onSelect: prop_types_1.default.func,
    busy: prop_types_1.default.bool,
    delay: prop_types_1.default.number,
    dropUp: prop_types_1.default.bool,
    duration: prop_types_1.default.number,
    disabledItems: prop_types_1.default.array,
    messages: prop_types_1.default.shape({
      emptyList: custom_prop_types_1.default.message
    }),
    onClick: prop_types_1.default.func,
    onKeyDown: prop_types_1.default.func,
    onKeyPress: prop_types_1.default.func,
    className: prop_types_1.default.string,
    tabIndex: prop_types_1.default.number,
    children: prop_types_1.default.node,
    onMove: prop_types_1.default.func
  });
  DropdownButton.defaultProps = {
    delay: 0,
    data: [],
    duration: 200
  };
  return DropdownButton;
}(react_1.default.PureComponent);
exports.DropdownButton = DropdownButton;